import { SET_SURVEY } from '@lyra/app/core/store/actions/plan.actions';
import { createReducer, on } from '@ngrx/store';

import { CREATE_COMMAND, CREATE_SUCCESS } from '../actions/medications.actions';
import * as actions from '../actions/questionnaire.actions';
import { SEND_WOMAN_HEALTH_SUCCESS } from '../actions/woman-health.actions';
import { featureKey, initialState } from '../states/questionnaire.state';

export { featureKey, initialState };

export const reducer = createReducer(
  initialState,
  // on(actions.INIT_APP_COMMAND, (state) => ({
  //   ...state,
  //   initialized: false,
  // })),
  // on(actions.INITIALIZED, (state) => ({
  //   ...state,
  //   initialized: true,
  // })),
  // on(actions.INIT_APP_SUCCESS, (state, { settings }) => ({
  //   ...state,
  //   AppId: settings.AppId!,
  //   Name: settings.Name!,
  //   Settings: new AppSetting(settings.Settings!),
  // })),
  on(actions.LOAD_STATE, (_state, { state }) => state),
  on(actions.SET_TYPE, (state, { quizType }) => ({
    ...state,
    type: quizType,
  })),
  on(actions.CHANGE_ROUTE, (state, { route }) => ({
    ...state,
    route,
    inProgress: route === 'pregnancy' || route === 'gender' ? false : true,
  })),
  on(SET_SURVEY, CREATE_SUCCESS, (state) => ({
    ...state,
    inProgress: false,
  })),
  on(actions.SET_PROGRESS, (state, { percent }) => ({
    ...state,
    progress: percent < 0 ? 0 : percent > 100 ? 100 : percent,
  })),
  on(actions.SET_LOADER, (state, { value }) => ({
    ...state,
    isLoading: value,
  })),
  on(actions.CALCULATE_AND_GET_RESULTS_COMMAND, CREATE_COMMAND, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(actions.CALCULATE_AND_GET_RESULTS_SUCCESS, CREATE_SUCCESS, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(SEND_WOMAN_HEALTH_SUCCESS, (state, { pregnancy }) => ({
    ...state,
    progress: pregnancy ? 100 : state.progress,
  })),

  on(actions.CLEAR, () => initialState),
);
